<template>
  <div class="vxa-aside" v-if="asideInitialed">
    <div class="vxa-aside-box" :class="{ 'vxa-aside-box_right': showDrawer }" v-show="asideShow">
      <div class="vxa-aside-right" :class="{ asideListOvermuch: asideListOvermuch, asideClosed: !asideExpanded }">
        <ul class="expand-aside-btn" @click="handleToExpand(true)" v-if="asideShow && !asideExpanded">
          <li>
            <i class="iconfont web-xiangzuojiantou"></i>
          </li>
        </ul>
        <ul
          :class="{ asideListOvermuch: asideListOvermuch }"
          class="close-aside-btn"
          @click="handleToExpand(false)"
          v-if="asideShow && asideExpanded"
        >
          <li>
            <i class="iconfont web-xiangyoujiantou"></i>
          </li>
        </ul>
        <ul
          :class="{ itemColor: item.active, asideListOvermuch: asideListOvermuch }"
          v-for="item in asideList"
          :key="item.type"
          @click="handleClick(item.type)"
          :style="item.style"
        >
          <template v-if="item.show">
            <li v-if="isShare(item)" v-xaPopover:popoverShare>
              <i :class="[item.icon, { active: item.active }]"></i>
              <span :class="['icon-label', { active: item.active }]">{{ item.promptTitle }}</span>
            </li>
            <li v-else-if="isWxService(item)" v-xaPopover:popoverWxService>
              <i :class="[item.icon, { active: item.active }]"></i>
              <span :class="['icon-label', { active: item.active }]">{{ item.promptTitle }}</span>
            </li>
            <li v-else>
              <i :class="[item.icon, { active: item.active }]"></i>
              <span :class="['icon-label', { active: item.active }]">{{ item.promptTitle }}</span>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <el-drawer
      custom-class="aside-drawer"
      direction="rtl"
      :visible.sync="showDrawer"
      :close-on-press-escape="false"
      :with-header="false"
      :show-close="false"
      size="460px"
      @open="handleDrawerOpen"
      @close="handleDrawerClose"
    >
      <template>
        <vxa-note
          class="vxa-aside-content"
          name="法规笔记"
          v-if="active.type == 'note' && active.show"
          ref="sideBarNote"
          @isShow="closeDrawer"
        ></vxa-note>
        <vxa-collect
          class="vxa-aside-content"
          name="收藏"
          @isShow="closeDrawer"
          v-if="active.type == 'collect' && active.show"
        ></vxa-collect>
        <vxa-track
          class="vxa-aside-content"
          ref="trak"
          @isShow="closeDrawer"
          name="足迹"
          v-if="active.type == 'track' && active.show"
        ></vxa-track>
      </template>
    </el-drawer>
    <xa-popover
      visible-arrow
      ref="popoverShare"
      placement="left"
      width="400"
      trigger="hover"
      popper-class="rulesContent"
    >
      <div class="imgArea">
        <v-qrcode :text="shareUrl" :width="153" :height="153" propId="shareQrcodeInSidebar"></v-qrcode>
      </div>
      <span style="margin-top: 25px">扫码分享</span>
    </xa-popover>
    <!--    此处应该废弃了，还没有删-->
    <el-popover ref="popoverShareDrawer" placement="left" width="400" trigger="hover" popper-class="rulesContent">
      <div class="imgArea">
        <v-qrcode :text="shareUrl" :width="153" :height="153" propId="shareQrcodeDrawer"></v-qrcode>
      </div>
      <span style="margin-top: 25px">扫码分享</span>
    </el-popover>
    <xa-popover
      visible-arrow
      ref="popoverWxService"
      placement="left"
      width="400"
      trigger="hover"
      popper-class="rulesContent"
    >
      <div class="imgArea">
        <img :src="wxServiceUrl" alt="" class="wxServiceQrcode" />
      </div>
      <span style="margin-top: 15px">扫码添加小安客服微信</span>
      <span style="margin-top: 8px">专享一对一服务</span>
    </xa-popover>
    <!--    此处也应该废弃了，但是没有删-->
    <el-popover ref="popoverWxServiceDrawer" placement="left" width="400" trigger="hover" popper-class="rulesContent">
      <div class="imgArea">
        <img :src="wxServiceUrl" alt="" class="wxServiceQrcode" />
      </div>
      <span style="margin-top: 15px">扫码添加小安客服微信</span>
      <span style="margin-top: 8px">专享一对一服务</span>
    </el-popover>
    <!-- 选择格式弹窗 -->
    <xa-dialog
      title="下载法规"
      :visible.sync="formatDialogVisible"
      :showClose="false"
      customClass="choose-format"
      width="320px"
    >
      <p class="tip-p">请选择需要下载的文件格式</p>
      <xa-radio-group v-model="formatRadio">
        <xa-radio label="word">word</xa-radio>
        <xa-radio label="pdf">pdf</xa-radio>
      </xa-radio-group>
      <span slot="footer" class="dialog-footer">
        <xa-button @click="formatDialogVisible = false">取 消</xa-button>
        <xa-button type="primary" @click="downloadFileHandle">确 定</xa-button>
      </span>
    </xa-dialog>
    <sentiment-dialog :sentimentVisiable.sync="sentimentVisiable" />
  </div>
</template>

<script>
import VxaNote from '@/view/aside/components/vxa-note'
import VxaCollect from '@/view/aside/components/vxa-collect'
import VxaTrack from '@/view/aside/components/vxa-track'
import VQrcode from '@/components/qrcode/qrcode.vue'
import Config from '@/config/config'
import Api from '@/service/api'
import sentimentDialog from './components/sentimentDialog.vue'
import limitAccessMixin from '@/mixins/limitAccessMixin'

export default {
  name: 'vxa-aside',
  mixins: [limitAccessMixin],
  components: {
    VxaNote,
    VxaCollect,
    VxaTrack,
    VQrcode,
    sentimentDialog
  },
  data() {
    const menuTypeShare = 'share'
    const menuTypeWxService = 'wx-service'
    const menuTypeGlobalFeedback = 'global-feedback'
    const menuTypeSentimentFeedback = 'feedback'
    return {
      menuTypeShare,
      menuTypeWxService,
      menuTypeGlobalFeedback,
      menuTypeSentimentFeedback,
      sentimentVisiable: false, // 舆情监控反馈弹框
      drawerAsideShow: true, // 抽屉内容内aside列表是否显示
      asideShow: true, // 侧边栏aside列表是否显示
      showDrawer: false,
      asideInitialed: false,
      shareUrl: '',
      reference: '',
      active: {
        show: false
      },
      asideList: [
        {
          promptTitle: '法规笔记',
          show: false,
          type: 'note',
          activeClass: 'animate-right-active',
          icon: 'iconfont web-noteicon', // 透明
          active: false,
          needLogin: true // 登录状态才会展示
        },
        {
          promptTitle: '收藏夹',
          show: false,
          type: 'collect',
          activeClass: 'animate-right-active',
          icon: 'iconfont web-ziyuan1', // 透明
          active: false,
          needLogin: true
        },
        {
          promptTitle: '打印',
          show: true,
          type: 'print',
          activeClass: 'animate-right-active',
          icon: 'iconfont web-icon_dayin-', // 透明
          active: false
        },
        {
          promptTitle: '下载',
          show: false,
          type: 'download',
          activeClass: 'animate-right-active',
          icon: 'iconfont web-download',
          active: false
        },
        {
          promptTitle: '足迹',
          show: false,
          type: 'track',
          activeClass: 'animate-right-active',
          icon: 'iconfont web-xianxing_zuji', // 透明
          active: false,
          needLogin: true
        },
        {
          promptTitle: '分享',
          show: false,
          type: menuTypeShare,
          activeClass: 'animate-right-active',
          icon: 'iconfont web-share', // 透明
          active: false
        },
        {
          promptTitle: '全屏',
          show: false,
          type: 'zoom',
          activeClass: 'animate-right-active',
          icon: 'iconfont web-quanping-quanping',
          active: false
        },
        {
          promptTitle: '在线咨询',
          show: true,
          type: 'online-service',
          activeClass: 'animate-right-active',
          icon: 'iconfont web-zaixiankefu7beifen',
          active: false
        },
        {
          promptTitle: '微信咨询',
          show: true,
          type: menuTypeWxService,
          activeClass: 'animate-right-active',
          icon: 'iconfont web-weixin2',
          active: false
        },
        // 舆情 我要反馈
        {
          promptTitle: '我要反馈',
          show: false,
          type: menuTypeSentimentFeedback,
          activeClass: 'animate-right-active',
          icon: 'iconfont web-jiluliuhen',
          active: false,
          needLogin: true,
          style: 'margin-top: 3px'
        },
        // 全局 我要反馈
        {
          promptTitle: '我要反馈',
          show: false,
          type: menuTypeGlobalFeedback,
          activeClass: 'animate-right-active',
          icon: 'iconfont web-jiluliuhen',
          active: false,
          needLogin: false,
          style: 'margin-top: 3px'
        }
      ],
      wxServiceUrl: 'https://cdn.in-hope.cn/plugins/xiaoan-web/EnterpriseWeiXin20230718.png',
      asideExpanded: true, // 侧边栏本身（非抽屉）是否展开
      formatDialogVisible: false,
      formatRadio: 'word'
    }
  },
  computed: {
    userData: function () {
      return this.$store.state.storeData.userData
    },
    asideListOvermuch() {
      const arr = this.asideList.filter(item => item.show)
      return arr && arr.length >= 9
    }
  },
  watch: {
    showDrawer: function (val) {
      if (!val) {
        this.asideList.forEach((item, i) => {
          item.active = false
        })
        this.active = {}
      }
    },
    $route: function (to, form, next) {
      const arr = to.meta.asideOption || []
      this.initAsideOption(arr)
    },
    '$store.state.rule.asideNoteState': function (val) {
      if (this.$store.state.rule.asideNoteState) {
        this.handleClick('note')
        this.$store.commit('asideNoteState', false)
      }
    }
  },
  created() {
    const arr = this.$route.meta.asideOption || []
    this.initAsideOption(arr)
    this.setShareUrl()
    this.refreshState()
  },
  methods: {
    isShare(item) {
      return this.menuTypeShare === item?.type
    },
    isWxService(item) {
      return this.menuTypeWxService === item?.type
    },
    refreshState() {
      if (this.$storage.isLogin()) {
        this.$axios.common
          .user_preference({
            module: 'SIDEBAR',
            business: ['SIDEBAR_STATE']
          })
          .then(res => {
            const list = res.data.returnObject || []
            if (list.length) {
              this.asideExpanded = list[0].preferenceValue !== 0
            }
          })
          .finally(() => {
            this.asideInitialed = true
          })
      } else {
        this.asideInitialed = true
      }
    },
    handleToExpand(toExpand) {
      this.asideExpanded = toExpand
      if (this.$storage.isLogin()) {
        this.$axios.common.update_user_preference({
          module: 'SIDEBAR',
          business: 'SIDEBAR_STATE',
          preferenceValue: toExpand ? 1 : 0
        })
      }
    },
    setShareUrl() {
      const pageRouter = this.$route.name
      const id = this.$route.params.id
      if (pageRouter === 'ruleDetail') {
        this.shareUrl = Api.share.ruleDetail + id
      } else if (pageRouter === 'afficheContent') {
        this.shareUrl = Api.share.afficheDetail + id
      } else if (pageRouter === 'researchReportDetail') {
        this.shareUrl = Api.share.detailReport + id
      } else if (pageRouter === 'inquiryLettersDetail') {
        this.shareUrl = Api.share.inquiryLettersDetail + id
      }
    },
    handleDrawerOpen() {
      this.drawerAsideShow = true
      this.asideShow = false
    },
    handleDrawerClose() {
      this.drawerAsideShow = false
      this.asideShow = true
    },
    handleClick(type) {
      const aside = this.asideList.find(ele => ele.type === type)
      const isOpenAside = ['note', 'collect', 'track']
      const closeAside = ['print', 'share']

      if (type === 'note' && this.$_limitAccess_limitAccess()) {
        return
      }

      if (aside.active) {
        this.showDrawer = false
      } else if (isOpenAside.includes(type)) {
        this.showDrawer = true
      }

      if (type === 'zoom') {
        aside.active = true
      } else if (isOpenAside.includes(type)) {
        this.asideList.forEach((item, i) => {
          item.active = false
          if (!closeAside.includes(type) && type === item.type) {
            item.active = true
          }
        })
      }

      if (type === 'zoom') {
        if (this.$store.state.storeData.scaleShowState) {
          aside.icon = 'iconfont web-icon_tianchong_quanping-quxiaoquanping'
          this.$store.commit('scaleShowState', false)
          return
        } else {
          aside.icon = 'iconfont web-quanping-quanping'
          this.$store.commit('scaleShowState', true)
          aside.active = false
          return
        }
      } else {
        const target = this.asideList.find(ele => ele.type === 'zoom')
        if (this.$store.state.storeData.scaleShowState) {
          target.icon = 'iconfont web-quanping-quanping'
        } else {
          target.icon = 'iconfont web-icon_xianxing_quanping-quxiaoquanping'
        }
      }

      switch (type) {
        case 'print':
          this.printf()
          return
        case 'download':
          this.downloadFile()
          return
        case 'track':
          break
        case 'share':
        case 'wx-service':
          return
        case 'online-service':
          this.access_detail()
          return
        case 'feedback':
          this.sentimentVisiable = true
          break
        default:
          break
      }
      this.active = aside

      if (aside.type === this.menuTypeGlobalFeedback) {
        this.$common.openWindow(
          'https://app.jingsocial.com/microFrontend/forms/jsf-forms/details/2TfY7NPT8PKqsKhjyYoDQY?lead_source_type=survey&lead_source_value=2TfY7NPT8PKqsKhjyYoDQY&promotion_code=survey_qrcode&promotion_value=3dvKDVQLxNCPX6mYRnuW7W&promotion_channel_id=oyULtXjABSobZWrufhAV7W&global_promotion_channel_id=Jdj3sNcL2BSYXFRNShXR9U&global_promotion_sub_channel_id=ZJZ2j3CFqGDnFBB4cWVFQA&appId=wx0b419adb07943f97'
        )
      }
    },
    downloadFile() {
      if (this.$_limitAccess_limitAccess()) {
        return
      }

      // 法规详情页侧边栏下载，校验用户是否有权限
      if (this.$route.name === 'ruleDetail' && !this.$common.hasPermission('LAW', 'BASIC')) {
        this.$store.commit('SHOWPERMISSIONDIALOG', 1)
        return
      }
      if (!this.$route.params.id) {
        this.$xaToast({ type: 'error', message: '未找到对应文件' })
        return
      }
      this.formatRadio = 'word'
      this.formatDialogVisible = true
    },
    async downloadFileHandle() {
      this.formatDialogVisible = false
      // 解构出oss下载地址并开始下载
      try {
        if (this.formatRadio === 'word') {
          const {
            data: { returnObject }
          } = await this.$axios.rule.downloadLawWord(this.$route.params.id)
          if (returnObject) {
            this.$common.download(returnObject)
          } else {
            this.$xaToast({ message: '文档暂时无法下载，请稍后再试', type: 'error' })
          }
        }
        if (this.formatRadio === 'pdf') {
          const { data } = await this.$axios.rule.downloadLawPdf(this.$route.params.id)
          if (data) {
            this.$common.download(data.returnObject, '', true, false)
          } else {
            this.$xaToast({ message: '文档暂时无法下载，请稍后再试', type: 'error' })
          }
        }
      } catch (err) {
        if (err.response?.status == 500 && err.response.data.returnMsg) {
          this.$xaToast({ message: err.response.data.returnMsg, type: 'error' })
        } else {
          this.$xaToast({ message: '文档暂时无法下载，请稍后再试', type: 'error' })
        }
      }
    },
    printf() {
      // 法规详情页侧边栏打印，校验用户是否有权限
      if (this.$route.name === 'ruleDetail' && !this.$common.hasPermission('LAW', 'BASIC')) {
        this.$store.commit('SHOWPERMISSIONDIALOG', 1)
        return
      }

      const printfContent = document.getElementById('content_right').innerHTML
      this.$common.printf(printfContent, Config.rulePrintStyle)
    },
    closeDrawer() {
      this.showDrawer = false
    },
    access_detail() {
      const params = {
        path: this.$route.path
      }
      if (this.$storage.isLogin()) {
        this.$axios.onlineService.access_detail(params)
      }
      this.$common.openWindow('/online-service')
    },
    initAsideOption(arr) {
      arr = [...arr, ...['online-service', 'wx-service']]

      if (!this.$auth.isInfaithUser()) {
        let showSentimentMenu = arr.indexOf('feedback') >= 0

        // 继续判断是否登录了
        if (showSentimentMenu) {
          const menuSentiment = this.asideList.find(item => item.type === this.menuTypeSentimentFeedback)
          // 如果舆情的反馈，需要登录才显示，则去判断登录
          if (menuSentiment?.needLogin) {
            showSentimentMenu = this.$storage.isLogin()
          }
        }

        // 有了舆情的反馈，则不添加全局反馈。否则会有两个反馈
        if (!showSentimentMenu) {
          arr = [...arr, this.menuTypeGlobalFeedback]
        }
      }
      this.asideList.forEach(item => {
        if (arr.includes(item.type) && ((item.needLogin && this.$storage.isLogin()) || !item.needLogin)) {
          item.show = true
        } else {
          item.show = false
        }
      })
    }
  }
}
</script>
<style lang="scss">
.el-popover.el-popper.rulesContent {
  width: 207px !important;
  height: 265px;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  overflow: hidden;
  padding: 25px;
  margin-right: 30px;
  box-sizing: border-box;
  .imgArea {
    width: 155px;
    height: 155px;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    margin: 0 auto;
    position: relative;
    img {
      display: block;
      width: 130px;
      height: 130px;
      margin: auto;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }
  }
  span {
    font-size: 12px;
    color: #323232;
    width: 100%;
    display: block;
    text-align: center;
  }
}
.choose-format {
  .el-dialog__body {
    text-align: center;
    .tip-p {
      margin-bottom: 16px;
    }
  }
}
</style>

<style lang="scss" scoped>
.vxa-aside {
  height: 0;
}
.vxa-aside-box {
  position: fixed;
  right: 0;
  top: 0;
  height: 100%;
  z-index: 1000;
  transition: all 0.2s;
}
.vxa-aside-box_right {
  right: 450px;
}
.vxa-aside-right {
  position: absolute;
  display: inline-block;
  left: -58px;
  bottom: 40%;
  transform: translateY(50%) scale(0.8);
  width: 58px;
  height: auto;
  transform-origin: right top;

  &.asideListOvermuch {
    left: -54px;
    width: 54px;
  }
  &.asideClosed {
    transform: translate(100%, 50%);
  }
  ul {
    cursor: pointer;
    &:nth-last-of-type(2) {
      li {
        margin-top: 3px;
      }
    }
    &.asideListOvermuch {
      li {
        width: 54px;
        height: 54px;
      }
    }
    &.close-aside-btn {
      li {
        height: 36px;
      }
    }
    &.expand-aside-btn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: -25px;
      li {
        width: 25px;
        height: 36px;
      }
    }
  }
  .itemColor {
    background-color: #000000;
  }
  li {
    color: white;
    padding: 2px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    width: 58px;
    height: 60px;
    background: rgba(50, 50, 50, 0.6);
    box-shadow: 0px 1px 7px 2px rgba(0, 0, 0, 0.15);
    border-radius: 2px 0px 0px 2px;
    margin-top: 3px;
    i {
      font-size: 21px;
    }
    i.active {
      color: #ffb148;
    }
    .icon-label {
      font-size: 12px;
      &.active {
        color: #ffb148;
      }
    }
    &:hover {
      background-color: black;
    }
  }
}
/deep/ .aside-drawer {
  overflow: inherit;
  .el-drawer__header {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    padding: 0;
  }
  .el-drawer__body {
    height: 100%;
  }
}
</style>
